import React, { Component } from "react";
import "./style.scss";

import { NormalButton, TableWrapper } from "component/common";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { withTranslation } from "react-i18next";
import { getCommonApi } from "redux/actions/common";

export class DownlineListClass extends Component {
  state = {
    activeTab: "",
    isOpenTreatmentDone: false,
    isActiveTab: "detail",
    headerDetails: [
      {
        label: "Branch",
        sortKey: false,
        width: "100px",
        divClass: "justify-content-start",
      },
      {
        label: "customer code",
        width: "180px",
        divClass: "justify-content-start",
      },

      {
        label: "Name",
        sortKey: false,
        width: "150px",
        divClass: "justify-content-start",
      },
      {
        label: "Reference",
        sortKey: false,
        width: "100px",
        divClass: "justify-content-start",
      },
      {
        label: "date of join ",
        sortKey: false,
        width: "100px",
        divClass: "justify-content-start",
      },
      {
        label: "Level",
        sortKey: false,
        width: "100px",
        divClass: "justify-content-start",
      },
    ],

    accountList: [],
    accountHeader: {},
    DetailList: [],
    isPrintPdfClick: false,
    oldDetailList: [],
    oldaccountHeader: {},
    isLoading: false,
    page: 1,
    meta: {},
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  componentDidMount() {
    this.getCustomerPointsAccount({});
    this.setState({
      isLoading: true,
    });
  }
  handlemainPagination = (page) => {
    this.getCustomerPointsAccount(page);
    console.log(page, "pagee");
  };

  getCustomerPointsAccount = (data) => {
    this.setState({
      isLoading: true,
    });
    let { accountHeader } = this.state;
    console.log(data);
    let { page = 1, limit = 12 } = data;
    this.props
      .getCommonApi(
        `customerreferral/downlinelist/?referral_id=${this.props.id}`
      )

      .then((key) => {
        console.log(getCommonApi, "api");
        let { data, header_data } = key;
        let { accountList } = this.state;
        if (data) {
          console.log(key.data, "key");
          this.setState({
            accountList: key.data.dataList,
            meta: key.data.pagination,
          });
        }
        accountList = data;
        accountHeader = header_data;
        this.setState({ accountList, accountHeader, isLoading: false });
      });
  };

  handleOpenDetail = async (data, tab) => {
    let { activeTab } = this.state;
    activeTab = tab;

    await this.setState({
      activeTab,
    });
    if (tab === "detail") {
      this.getDetailList(data.id);
    } else {
      this.getOldDetailList(data.id);
    }
  };

  handleBack = () => {
    let { activeTab } = this.state;
    activeTab = "";
    this.setState({
      activeTab,
      DetailList: [],
    });
    this.getAccountData();
  };

  render() {
    let {
      treatmentList,
      headerDetails,
      accountList = [],
      accountHeader = {},
      activeTab,

      isLoading,
      meta,
    } = this.state;

    let { t } = this.props;
    return (
      <div className="treatment-account">
        {console.log(accountList, "accountlist")}
        <div className="col-12 mt-2">
          <div className="table">
            <TableWrapper
              headerDetails={headerDetails}
              queryHandler={this.handlemainPagination}
              pageMeta={meta}

              // isEmpty={accountList.length === 0 ? true:false}
            >
              {isLoading ? (
                <tr>
                  <td colSpan="16">
                    <div class="d-flex mt-5 align-items-center justify-content-center">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              ) : accountList.dataList && accountList?.dataList.length > 0 ? (
                accountList?.dataList?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <div className="text-left">{item.site_code}</div>
                      </td>

                      <td>
                        <div className="text-left">{item.customer_code}</div>
                      </td>

                      <td>
                        <div className="text-left">{item.customer_name}</div>
                      </td>

                      <td>
                        <div className="text-left">
                          {item.customer_referenceno}
                        </div>
                      </td>

                      <td>
                        <div className="text-left">{item.dateofjoin}</div>
                      </td>

                      <td>
                        <div className="text-left">{item.level}</div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="16">
                    <div class="d-flex  align-items-center justify-content-center fs-18">
                      No data available
                    </div>
                  </td>
                </tr>
              )}
            </TableWrapper>
          </div>
        </div>
        <div className="col-12 d-flex justify-center">
          {activeTab === "detail" || activeTab === "old" ? (
            <NormalButton
              buttonClass={"back mr-3"}
              mainbg={true}
              className="col-12 fs-15 "
              label="Back"
              onClick={() => this.handleBack()}
            />
          ) : (
            ""
          )}
          {activeTab === "old" ? null : (
            <NormalButton
              buttonClass={"print"}
              // mainbg={true}
              className="col-12 fs-15 "
              label="Print"
              // outline={false}
              onClick={() => this.setState({ isPrintPdfClick: true })}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
    },
    dispatch
  );
};

export const DownlineList = withTranslation()(
  connect(null, mapDispatchToProps)(DownlineListClass)
);
